import { useState } from "react";
import { Loader2, MailCheck } from "lucide-react";

import { AuthLayout, AuthLink } from "@/components/auth/AuthLayout";
import { authService } from "@/services/authService";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AUTH } from "@/constants/testIds";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await authService.forgotPassword(email);
      setMessage(res.message);
      setSent(true);
    } catch (err) {
      // Still show generic success to avoid account enumeration.
      setMessage("If an account exists for that email, a password reset link has been sent.");
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Reset your password"
      subtitle="Enter your email and we'll send you a reset link."
      footer={<>Remembered it? <AuthLink to="/login" testId={AUTH.toSignin}>Back to sign in</AuthLink></>}
    >
      {sent ? (
        <Alert className="border-success/30 bg-success/5" data-testid={AUTH.success}>
          <MailCheck className="h-4 w-4 text-success" />
          <AlertDescription>{message}</AlertDescription>
        </Alert>
      ) : (
        <form onSubmit={onSubmit} className="space-y-5" data-testid={AUTH.forgotPage} noValidate>
          <div className="space-y-1.5">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" autoComplete="email" required value={email}
              onChange={(e) => setEmail(e.target.value)} data-testid={AUTH.email} placeholder="you@example.com" />
          </div>
          <Button type="submit" className="w-full" disabled={loading} data-testid={AUTH.submit}>
            {loading ? <><Loader2 className="h-4 w-4 animate-spin" /> Sending…</> : "Send reset link"}
          </Button>
        </form>
      )}
    </AuthLayout>
  );
}
